import { render, staticRenderFns } from "./PlanBenefitsList.vue?vue&type=template&id=9344cde2&scoped=true"
import script from "./PlanBenefitsList.vue?vue&type=script&lang=js"
export * from "./PlanBenefitsList.vue?vue&type=script&lang=js"
import style0 from "./PlanBenefitsList.vue?vue&type=style&index=0&id=9344cde2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9344cde2",
  null
  
)

export default component.exports